import React, { useEffect } from 'react';
import Lottie from 'react-lottie';
import { useUserInfo } from '@repository/auth/useUserInfo';
import folder from '@graphic/folder.json';
import { useNHISCompaniesReport } from '@repository/nhis/useNHIS';
import NhisCompanyReportHistoryDto from '@domain/rs/nhis/NhisCompanyReportHistoryDto';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const options = {
  loop: true,
  autoplay: true,
  animationData: folder,
};

interface Step4Props {
  nextStep: () => void;
  setSelectedCompanies: React.Dispatch<React.SetStateAction<NhisCompanyReportHistoryDto[]>>;
}

const Step4 = ({ nextStep, setSelectedCompanies }: Step4Props) => {
  const { data: userData } = useUserInfo();
  const userName = userData?.name || '회원';
  const { data: companiesData, isSuccess } = useNHISCompaniesReport();

  useEffect(() => {
    if (!isSuccess) return;
    setSelectedCompanies(companiesData?.companies || []);

    setTimeout(() => {
      nextStep();
    }, 2000);
  }, [isSuccess]);

  return (
    <div className={cx('area')}>
      <div className={cx('wrap')}>
        <em className={cx('desc')}>{userName}님의 경력 정보를 불러올게요.</em>
      </div>
      <div className={cx('contentsArea')}>
        <Lottie options={options} isClickToPauseDisabled />
      </div>
    </div>
  );
};

export default Step4;
